export default __webpack_public_path__ + "menu-collections-smop-icon.a6590b22cd46394f18cd6393fe3d96df.svg";